import { cva } from "class-variance-authority";

const ORGANIZE_STATE =
  "data-[state=organizing]:cursor-grab data-[state=organizing]:opacity-50";

export const buttonVariants = cva(
  // 1. BASE: Estética minimalista + estado organizador integrado
  `inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all duration-200 active:scale-[0.98] 
  text-xs  tracking-[0.12em] uppercase 
  disabled:pointer-events-none disabled:opacity-30 [&_svg]:shrink-0 ${ORGANIZE_STATE}`,
  {
    variants: {
      design: {
        default:
          "bg-primary-strong text-white hover:bg-primary-strong/90 border-none",

        // `bg-background` y no `bg-transparent`: sin fill propio el mismo
        // boton se leia distinto sobre una card que sobre un bloque `bg-muted`.
        // Dentro de `brand-band` el token ya esta remapeado, asi que sigue
        // pintando navy y el CTA de la banda no cambia.
        outline:
          "border border-border/60 bg-background text-foreground hover:bg-muted/30 hover:border-border data-[state=active]:bg-muted/50",

        // `isActive` had no visual here (the only design without one), so an
        // active ghost read as idle — brand tint, same language as an active chip.
        ghost:
          "text-muted-foreground hover:text-foreground hover:bg-muted/20 " +
          "data-[state=active]:bg-primary/10 data-[state=active]:text-primary",

        // Quiet delete/remove affordance (icon row-actions all over the tap +
        // editor UIs): muted idle, destructive only on hover. NOT `destructive`
        // (that's a solid-fill confirm button).
        "destructive-ghost":
          "text-muted-foreground hover:text-destructive hover:bg-destructive/10",

        // Dashed "+ add" affordance (add room/floor/deal/stage/window/lang…):
        // outlined-dashed idle, brand tint on hover.
        dashed:
          "border border-dashed border-border/60 bg-transparent text-muted-foreground hover:text-primary hover:border-primary/40 hover:bg-primary/5",

        card:
          "bg-card text-foreground border border-border/60 shadow-sm hover:bg-muted/40 data-[state=active]:bg-muted/60",

        glass:
          "bg-background/8 backdrop-blur-xl border border-black/8 dark:border-white/10 text-white shadow-sm " +
          "hover:bg-background/15 hover:border-white/20 " +
          "data-[state=active]:bg-primary/80 hover:data-[state=active]:border-white/20 data-[state=active]:text-white ",

        success:
          "bg-success/10 text-success-strong border border-success/20 hover:bg-success/20",

        destructive:
          "bg-destructive/10 text-destructive border border-destructive/20 hover:bg-destructive/20",

        pill: "rounded-full bg-white/15 text-white normal-case tracking-normal hover:bg-white/25 active:bg-white/25 data-[state=active]:bg-white data-[state=active]:text-slate-900",
      },
      size: {
        // Dense tier for dashboard toolbars / row actions (was hand-rolled
        // as `inline-flex rounded-lg border text-xs` all over the dashboard).
        xs: "h-7 px-2.5 rounded-lg text-xs gap-1.5",
        sm: "h-9 px-4 rounded-md text-xs",
        default: "h-11 px-6 rounded-lg",
        // CTA de marketing. Con `text-xs` heredado el glifo quedaba en 12px
        // dentro de una caja de 56px (alto ÷ texto = 4.7, padding-x ÷ texto =
        // 3.3): demasiada caja y muy poca tinta, leía como etiqueta flotando.
        // Las piezas de redes usan 3.2 y 2.1 con peso 700 — esto se acerca sin
        // romper la altura, que ya está en 35 sitios.
        lg: "h-14 px-8 rounded-xl text-sm font-medium tracking-[0.16em]",
        // Tamaño táctil del viewer (HUD, overlays de captura/dibujo/medida,
        // BookingModal): más bajo que `lg` pero con área de toque cómoda. Se
        // llamaba `xl`, que mentía — sugería "más grande que lg" y no lo es.
        touch: "h-12 px-6 rounded-lg",
        // Dense square icon button for inline row-actions (menu/staff/shift
        // rows) where the 44px `icon` is too big and multiple sit in a row.
        "icon-sm": "h-8 w-8 rounded-lg",
        icon: "h-11 w-11 rounded-lg",
        "icon-lg": "h-12 w-12 rounded-lg",
      },
    },
    defaultVariants: {
      design: "default",
      size: "default",
    },
  },
);
